// extracted by mini-css-extract-plugin
export var dropdown = "_uq-0";
export var imageWrapper = "_uq-3";
export var itemNameContainer = "_uq-1";
export var productImage = "_uq-2";
export var spinnerWrapper = "_uq-4";